import AutomaticDrawer from 'components/Drawers/AutomaticDrawer';
import useQueryParams from 'hooks/useQueryParams';
import UserJourney from 'modules/ReportModule/components/UserJourney';
import React from 'react';
import { Divider, Form } from 'antd';
import UserJourneyFilterForm from './components/UserJourneyFilterForm';

const UserJourneyDrawer = (props) => {
  const { setUrlParams } = useQueryParams();

  const [form] = Form.useForm();

  const onSubmit = (values) => {
    const filtered = Object.fromEntries(
      Object.entries(values).filter(([_, v]) => v && v.trim() !== '')
    );
    setUrlParams({ report: 'user_journey', ...filtered });
  };

  return (
    <AutomaticDrawer size='large' title='Detailed Journey View' {...props}>
      <UserJourneyFilterForm
        form={form}
        onSubmit={onSubmit}
        stylesProps='md:grid-cols-3 sm:grid-cols-2'
      />

      <Divider />

      <UserJourney />
    </AutomaticDrawer>
  );
};

UserJourneyDrawer.requiredParams = {
  report: (report) => report === 'user_journey',
  user_id: () => true,
  event_id: () => true,
  session_id: () => true,
};

UserJourneyDrawer.useDrawer = (accountID) => {
  const { setUrlParams, removeParams } = useQueryParams();

  const open = (data = {}) => {
    setUrlParams({ report: 'user_journey', ...data });
  };

  const close = () => removeParams(['report', 'user_id', 'event_id', 'session_id']);

  return {
    open,
    close,
  };
};

export default UserJourneyDrawer;
